import { SideMenuLink } from './SideMenuLink';

export class SideMenuData {
  title:string;
  links:SideMenuLink[];
}



// WEBPACK FOOTER //
// /Users/Jose.Soto/Documents/Websites/SecretSanta/src/app/models/SideMenuData.ts